module.exports = __webpack_public_path__ + "09b152468677556f6e0b2ad018b19a8a.jpg";